import { useEffect, useState } from "react";
import Loader from "../UI/Loader";
import Alert from "../UI/Alert";
import VideoUploaderForm from "./VideoUploaderForm";
import VideoKindTabs from "./VideoKindTabs";
import {
  getVideoTutorialInicioQuizService,
  putVideoTutorialInicioQuizFileService,
  putVideoTutorialInicioQuizUrlService,
  deleteVideoTutorialInicioQuizService,
} from "../../services/quiz/quiz.service.js";

const normalizeVideoUrl = (raw) => {
  if (!raw) return null;
  if (/^https?:\/\//i.test(raw)) return raw;
  const base = (process.env.REACT_APP_API_URL || "").replace(/\/+$/, "");
  const path = raw.startsWith("/") ? raw : `/${raw}`;
  return `${base}${path}`;
};

const extractUrls = (data) => ({
  tutorial: normalizeVideoUrl(
    data?.tutorial?.video_url_generada ||
      data?.tutorial?.video_url_externa ||
      data?.video_tutorial_url_generada ||
      data?.video_url,
  ),
  instrucciones: normalizeVideoUrl(
    data?.instrucciones?.video_url_generada ||
      data?.instrucciones?.video_url_externa,
  ),
});

const VideoTutorialInicioQuiz = () => {
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [deleting, setDeleting] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);

  const [urls, setUrls] = useState({ tutorial: null, instrucciones: null });
  const [activeKind, setActiveKind] = useState("tutorial");

  useEffect(() => {
    const fetchVideo = async () => {
      try {
        setLoading(true);
        setError(null);
        const data = await getVideoTutorialInicioQuizService();
        setUrls(extractUrls(data));
      } catch (err) {
        setError(
          err.response?.data?.message ||
            err.response?.data?.detail ||
            "Error al cargar los videos",
        );
      } finally {
        setLoading(false);
      }
    };
    fetchVideo();
  }, []);

  const handleSubmit = async ({ file, url }) => {
    setError(null);
    setSuccess(null);
    try {
      setSaving(true);
      const data = file
        ? await putVideoTutorialInicioQuizFileService(file, activeKind)
        : await putVideoTutorialInicioQuizUrlService(url, activeKind);
      setUrls(extractUrls(data));
      setSuccess(
        activeKind === "instrucciones"
          ? "Video de instrucciones actualizado."
          : "Video de bienvenida actualizado.",
      );
    } catch (err) {
      setError(
        err.response?.data?.message ||
          err.response?.data?.detail ||
          "Error al guardar el video",
      );
    } finally {
      setSaving(false);
    }
  };

  const handleDelete = async () => {
    if (!window.confirm("¿Eliminar este video?")) return;
    setError(null);
    setSuccess(null);
    try {
      setDeleting(true);
      const data = await deleteVideoTutorialInicioQuizService(activeKind);
      setUrls(extractUrls(data));
      setSuccess("Video eliminado.");
    } catch (err) {
      setError(
        err.response?.data?.message ||
          err.response?.data?.detail ||
          "Error al eliminar el video",
      );
    } finally {
      setDeleting(false);
    }
  };

  if (loading) {
    return (
      <div className="py-3">
        <Loader center text="Cargando videos..." delay={200} />
      </div>
    );
  }

  const currentVideoUrl = urls[activeKind];
  const existe = Boolean(currentVideoUrl);

  return (
    <div>
      {error && <Alert message={error} variant="error" onClose={() => setError(null)} />}
      {success && <Alert message={success} variant="success" onClose={() => setSuccess(null)} />}

      <VideoKindTabs
        activeKind={activeKind}
        onChange={(k) => {
          setActiveKind(k);
          setError(null);
          setSuccess(null);
        }}
        availability={{
          tutorial: Boolean(urls.tutorial),
          instrucciones: Boolean(urls.instrucciones),
        }}
      />

      <VideoUploaderForm
        key={activeKind}
        currentVideoUrl={currentVideoUrl}
        existe={existe}
        saving={saving}
        deleting={deleting}
        onSubmit={handleSubmit}
        onDelete={existe ? handleDelete : undefined}
        submitLabel={existe ? "Actualizar video" : "Guardar video"}
      />
    </div>
  );
};

export default VideoTutorialInicioQuiz;
